import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { CardData, SectionCardSaudeData } from '@fcp/lib-ui';

@Injectable({ providedIn: 'root' })
export class SectionCardSaudeContainerService {
  private host =
    environment.configCMS.endPointAPI + environment.configCMS.endPointAPP;

  constructor(private router: Router, private http: HttpClient) {}

  public getDestaquePlanosSaude(id: string): Observable<any> {
    return this.getDestaquePlanosSaudeContents(id).pipe(
      map(res =>
        this.buildReponseHighlightHealthObject(this.extractResult(res))
      ),
      catchError(error => {
        console.log('error', error);
        this.router.navigate(['/nao-encontrado']);
        return of(null);
      })
    );
  }

  private extractResult(res) {
    return res.data.queryDestaquePlanosSaudeContents[0].data;
  }

  private getDestaquePlanosSaudeContents(id: string): Observable<any> {
    const payload = {
      query: `
      {
        queryDestaquePlanosSaudeContents(filter: "id eq '${id}'") {
          data {
            titulo {
              iv
            }
            subtitle {
              iv
            }
            nome {
              iv
            }
            cards {
              iv {
                titulo
                subtitulo
                modal {
                  id
                }
                imagem {
                  url
                }
                imageHover {
                  url
                }
                hasHover
              }
            }
          }
        }
      }`
    };

    return this.send(payload);
  }

  private buildReponseHighlightHealthObject(highlightHealth: any) {
    let cards: Array<CardData> = [];

    if (highlightHealth.cards) {
      cards = highlightHealth.cards.iv.map(
        (card): CardData => {
          return {
            image: card.imagem && card.imagem[0] ? card.imagem[0].url : '',
            imageHover: card.imageHover && card.imageHover[0] ? card.imageHover[0].url : '',
            hasHover: card.hasHover,
            modal: card.modal,
            subtitle: card.subtitulo,
            title: card.titulo
          };
        }
      );
    }

    return {
      title: highlightHealth.titulo ? highlightHealth.titulo.iv : '',
      subtitle: highlightHealth.subtitulo ? highlightHealth.subtitulo.iv : '',
      cards
    } as SectionCardSaudeData;
  }

  private send(payload): Observable<any> {
    const url = `${this.host}graphql`;
    return this.http.post(url, payload);
  }
}
